<template>
<div ref="pageContainer" style="width: 100%;height: auto;padding-bottom: 100px;padding-top: 60px;" class="flex flex-column align-center">
  <Breadcrumb :value="[$t('h.tabName1'),$t('h.tabName2'),$t('h.tabName2Item3')]"/>
  <div style="width: 1100px;background: white;border-radius: 4px;padding: 20px;">
    <div style="font-weight: 500;font-size: 24px;color: #333333;padding: 30px 0 10px;text-align: center;"><b>{{ detail.title }}</b></div>
    <div style="font-weight: 500;font-size: 14px;color:rgb(153, 153, 153);padding: 10px 0 20px;text-align: center;">Date：{{time}}</div>
    <div style="font-size: 18px;color: #333333;line-height: 32px;">
      <div ref="detailContent" class="detail-content" :class="{ 'chinese-indent': isChinese }" v-html="detail.description"></div>
    </div>
    <div style="display: flex; justify-content: space-between;font-size: 14px;color: #999999;padding: 24px 0;">
      <span style="visibility: hidden;">来源：南报网</span>

	  <span><a href="javascript:void(0)" onclick="history.back()">返回</a></span>
    </div>
<!--    <div style="font-size: 14px;color: #666666;">
      <div>上一篇：<a>"国蛟一号"国内首个陆缆穿海工程施工进入冲刺阶段</a></div>
      <div>下一篇：<a>"国蛟二号"国内首个陆缆穿海工程施工进入冲刺阶段</a></div>
    </div>-->
  </div>
</div>
</template>

<script>
import {queryArticleById, queryArticlePageList} from "@/assets/api";
import {setSeoMeta} from "@/assets/seo";

export default {
  name: "DynamicDetail",
  data(){
    return {
      detail: {},
      time: ""
    }
  },
  created() {
    if(this.$route.query.id){
      this.getDetail(this.$route.query.id)
    } else {
      this.$message.error("当前文章不存在", 2.5, () => {
        this.$router.replace('/dynamic')
      })
    }
  },
  methods: {
    getDetail(id){
      this.$axios.get(queryArticleById + `/${id}`, {}).then(res => {
        if (res.data.success) {
          if(this.$language === 'ZH'){
            this.detail = res.data.result.itemsCn
          } else {
            this.detail = res.data.result.itemsEn
          }
          let time = res.data.result.updateTime || res.data.result.createTime
          this.time = this.$moment(time).format('YYYY-MM-DD')
          // 真实标题/描述写入 SEO meta（爬虫与社交分享卡片生效）
          const raw = res.data.result
          const item = this.detail
          setSeoMeta({
            title: (item && (item.title || item.subTitle) ? item.title || item.subTitle : (raw.title || '展会动态')) + ' | wire China 2026',
            description: (item && (item.description || item.subTitle)) || '',
            keywords: (item && item.title) || raw.title || ''
          })
          this.$nextTick(() => {
            this.fixImageAlignment()
          })
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    fixImageAlignment() {
      const container = this.$refs.detailContent
      if (!container) return

      const images = container.querySelectorAll('img')
      images.forEach(img => {
        // 检查父元素是否有 text-align: center
        let parent = img.parentElement
        let foundCenterAlign = false

        while (parent && parent !== container) {
          const style = window.getComputedStyle(parent)
          const textAlign = style.textAlign
          const inlineStyle = parent.getAttribute('style') || ''

          if (textAlign === 'center' || inlineStyle.includes('text-align: center') || inlineStyle.includes('text-align:center')) {
            foundCenterAlign = true
            break
          }
          parent = parent.parentElement
        }

        // 检查 img 自身的 style
        const imgStyle = img.getAttribute('style') || ''
        const imgInlineStyle = img.getAttribute('style') || ''

        if (foundCenterAlign || imgInlineStyle.includes('text-align: center') || imgInlineStyle.includes('text-align:center')) {
          img.style.display = 'block'
          img.style.marginLeft = 'auto'
          img.style.marginRight = 'auto'
        }
      })

      // 同时处理 p/div 的 text-align: center
      const centerElements = container.querySelectorAll('[style*="text-align: center"], [style*="text-align:center"]')
      centerElements.forEach(el => {
        el.style.textAlign = 'center'
      })
    }
  },
    computed: {
      isChinese() {
        return this.$language === 'ZH';
      }
    }
}
</script>

<style scoped>
::v-deep .chinese-indent {
  text-indent: 2em;
}

::v-deep .detail-content img {
  max-width: 100%;
  height: auto;
}
</style>
